'use strict'

if document.referrer.indexOf('qa/') isnt -1
  $(
    if (navigator.userAgent.indexOf('Opera') isnt -1)
    then (
      if document.compatMode is 'BackCompat'
      then 'body'
      else 'html'
    )
    else 'html, body'
  ).animate({
    scrollTop: $('.p-lead').offset().top - $('.p-header > .headroom').outerHeight()
  }, 0)
